
































































import { Component, Vue } from "vue-property-decorator";
import Footer from "@/components/Footer.vue";
import CityService from "../services/city.service";

@Component({
  components: {
    Footer,
  },
})
export default class ContactUs extends Vue {
  private service = new CityService();

  private form: any = {};
  private loading = false;
  private inquirySuccess = false;

  sendInquiry() {
    this.loading = true;
    this.service.sendInquiry(this.form).then((res) => {
      this.loading = false;
      this.inquirySuccess = true;
      this.form = {};
    });
  }
}
